import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("edf_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const LOGOS = {
  main: "https://customer-assets.emergentagent.com/job_517577b6-eaeb-4116-a360-8c8848c3dc9b/artifacts/z3s731an_unnamed%20%281%29.png",
  footer: "https://customer-assets.emergentagent.com/job_517577b6-eaeb-4116-a360-8c8848c3dc9b/artifacts/ec9sx99z_unnamed.png",
};

export const CONTACT_INFO = {
  address: "BORBIL NO 2, DIGBOI, ASSAM - 786171",
  phone: "+91 7002263481",
  email: "edswelfarefoundation@gmail.com",
};

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
